import store from '@/store'
import Vue from 'vue'

//自定义指令
Vue.directive("hasPermi", {
	bind: function(el, binding, vnode) { //当前元素
		//console.log("bind-----" + el.parentNode) // bind 时父节点为 null
		//binding.def.hasPermi(binding.value);
	},
	inserted: function(el, binding, vnode) { //可以操作当前的父元素  // inserted 时父节点存在。
		const {
			value
		} = binding; //取出value值  也可 binding.value
		const all_permission = "*:*:*"; //通配符 管理员角色用
		const permissions = store.getters['user/permissions'];
		if (value && value instanceof Array && value.length > 0) {
			//some() 方法会依次执行数组的每个元素：如果有一个元素满足条件，则表达式返回true否则返回false , 剩余的元素不会再执行检测。
			const hasPermissions = permissions.some(item => {
				return item === all_permission || value.includes(item);
			})
			if (!hasPermissions) {
				// el.parentNode && el.parentNode.removeChild(el);	// 暂时屏蔽按钮权限
			}
		} else {
			throw new Error("未设置权限标识");
		}
	},
	hasPermi(val) { //自定义方法 
		console.log(val); //binding.def.hasPermi 调用 
	}
})
